export const restaurants = [
	{
		id: 0,
		name: "L'Échappée",
		address: "9 rue de Paris, 75005 Paris",
		description_short: "Un moment à part",
		description_long:
			"L'Échappée réunit tous les critères pour un repas réussi : une cuisine gastronomique, récompensée d'une étoile au Guide Michelin, et une vue légendaire sur la célèbre cathédrale de Notre-Dame. Que demander de plus ?",
		img: "https://img-3.journaldesfemmes.fr/H20vVHBaJmY2sDsnU2QmOldtvNI=/1500x/smart/e215672b6c2c4199accb23e4406c5967/ccmcms-jdf/32506409.jpg",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 1,
		name: "Le Bain",
		address: "75bis rue de l'eau, 29000 Quimper",
		description_short: "Familial et végétarien",
		description_long:
			"Pour les amoureux des légumes et des produits de saison, Le Bain est un endroit idéal. Le tout dans un lieu agréable et cosy.",
		img: "https://visitbath.co.uk/imageresizer/?image=%2Fdbimgs%2FNav%20Landscape%20-%20The%20Ivy%20Bath%20Brasserie%20Interior%20Ceiling%281%29.jpg&action=FeaturedItems3x2",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 2,
		name: "Aux filets bleus",
		address: "67 route du Port de Locquémeau Pointe de Sehar, 22300 Trédrez-Locquémeau",
		description_short: "Restaurant de poissons",
		description_long:
			"Aux filets bleus vous accueille pour venir déguster la pêche du jour ! Dans un cadre magnifique avec vue directe sur la mer.",
		img: "https://lh3.googleusercontent.com/p/AF1QipPWYcBjbpnej2FQoHGYsqQmCY1NOA7v5n-0L49z=s1360-w1360-h1020",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 3,
		name: "Le Balto",
		address: "15 Rue Mazarine, 75006 Paris",
		description_short: "Brasserie parisienne",
		description_long:
			"Soupe à l'oignon, charcuterie et steaks servis dans une brasserie haut de gamme avec des salles décorées dans des styles différents.",
		img: "https://lh5.googleusercontent.com/p/AF1QipM9Pcn6WnwttgRK8Dg9MHFkGkyfwYkBz95Ypqfu=w1200-h969-p-k-no",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 4,
		name: "Au Bascou",
		address: "38 rue Réaumur, 75002 Paris",
		description_short: "Cuisine basque et chaleureuse",
		description_long: "Plats basques gastronomiques dans un lieu aux tons chauds et colorés, avec chaises et comptoir en bois.",
		img: "https://i.f1g.fr/media/ext/299x250/scope.lefigaro.fr/static/media/Restaurants/photo_huge_au_bascou_75003.jpg",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 5,
		name: "Le Bastringue",
		address: "67 quai de Seine, 75019 Paris",
		description_short: "Brasserie pittoresque de spécialités françaises",
		description_long:
			"Cuisine et boissons de brasserie parisienne classique dans un restaurant établi de longue date avec terrasse au bord du canal.",
		img: "https://lh3.googleusercontent.com/p/AF1QipOTX7AS7zZ5qVJWERvy8rru_MA22MXDv5pTAcpE=s1360-w1360-h1020",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
	{
		id: 6,
		name: "Higuma",
		address: "32bis Rue Sainte-Anne, 75001 Paris",
		description_short: "Cuisine japonaise, cadre à l'ambiance détendue",
		description_long: "Restaurant japonais de style décontracté servant ramens, plats sautés et donburis, accompagnés de bière et de saké.",
		img: "https://media-cdn.tripadvisor.com/media/photo-s/10/b0/a3/93/gyoza.jpg",
		menu: {
			entrees: ["entree 1", "entree 2"],
			dishes: ["plat 1", "plat 2", "plat 3"],
			deserts: ["desert 1", "desert 2"],
		},
	},
];
